export default "__VITE_ASSET__ed993c26__";